import GreenCheckIcon from "@/common/svgs/green-check";
import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Entry } from "../models/entry";

type Props = {
	entries: Entry[];
	onSelect: (entry: Entry) => void;
};

export default function EntriesTable({ entries, onSelect }: Props) {
	return (
		<Table>
			<TableHeader className="bg-white-30 rounded-[32px] border-0 bg-blend-overlay">
				<TableRow className="border-0!">
					<TableHead className="web-body-b1 rounded-l-[32px] p-4 text-white">
						Entries
					</TableHead>
					<TableHead className="web-body-b1 p-4 text-white">Included</TableHead>
					<TableHead className="web-body-b1 p-4 text-white">Price</TableHead>
					<TableHead className="rounded-r-[32px]"></TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{entries.map((entry) => (
					<TableRow key={entry.id} className="border-0">
						<TableCell className="web-body-b2-medium rounded-l-[32px] px-4 text-left text-white">
							{entry.count} entries
						</TableCell>
						<TableCell className="px-4 text-left">
							<div className="flex flex-row gap-2">
								<GreenCheckIcon transparent />
								<p className="web-body-b1 text-white-80">
									Access to {entry.draw}
								</p>
							</div>
						</TableCell>
						<TableCell className="flex flex-col gap-2 px-4 py-6 text-left">
							<p className="web-body-b2-medium text-white">${entry.price}</p>
							<p className="web-body-b1 text-white-80">Once only payment</p>
						</TableCell>
						<TableCell className="rounded-r-[32px]">
							<Button
								variant="secondary"
								onClick={() => onSelect(entry)}
								className="bg-white-10 border-white-20 w-50 text-white"
							>
								Get entries
							</Button>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
}
